import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions, mapGetters } from 'vuex';
import ToastificationContent from '@/components/ToastificationContent';
import formValidation from '@/helpers/form-validation';
import utils from '@/helpers/utils.js';
export default {
  name: 'AddSidebarLevel',
  props: {
    defaultValue: {
      type: undefined,
      required: false,
      default: function _default() {
        return {
          languages: {
            'pt-br': {
              title: ''
            }
          }
        };
      }
    },
    series: {
      type: undefined,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    },
    levelOrder: {
      type: [String, Number],
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      isVisible: this.value,
      forceRenderKey: 0,
      forceRenderKeySlug: 0,
      level: {
        languages: {
          'pt-br': {
            title: '',
            name: ''
          }
        },
        status: 'active',
        isFree: false,
        seriesId: this.$route.params.seriesId,
        order: this.levelOrder
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    slugs: 'level/slugs'
  })), {}, {
    form: function form() {
      var _formValidation = formValidation(this.resetLevel),
          refFormObserver = _formValidation.refFormObserver,
          getValidationState = _formValidation.getValidationState,
          resetForm = _formValidation.resetForm;

      return {
        refFormObserver: refFormObserver,
        getValidationState: getValidationState,
        resetForm: resetForm
      };
    },
    getValidationState: function getValidationState() {
      return this.form.getValidationState;
    },
    resetForm: function resetForm() {
      return this.form.resetForm;
    }
  }),
  watch: {
    defaultValue: function defaultValue(newValue) {
      this.level = newValue;
      this.forceRenderKey += 1;
      this.resetLevel();
    },
    value: function value() {
      this.isVisible = this.value;
    },
    isVisible: function isVisible() {
      if (this.isVisible === false) {
        this.level = {
          languages: {
            'pt-br': {
              title: '',
              name: ''
            }
          },
          status: 'active',
          isFree: false,
          seriesId: this.$route.params.seriesId,
          order: this.levelOrder
        };
        this.$emit('update:value', false);
      }
    },
    level: {
      handler: function handler() {
        if (this.level.languages[this.$i18n.locale].title) {
          this.createSlug(this.level.languages[this.$i18n.locale].title);
        }
      },
      deep: true
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    create: 'level/create',
    update: 'level/update'
  })), {}, {
    collapseDrawer: function collapseDrawer() {
      this.isVisible = !this.isVisible;
    },
    resetLevel: function resetLevel() {
      this.$emit('update:defaultValue', this.defaultValue);
    },
    createSlug: function createSlug(title) {
      var slug = utils.convertExpressionToSlug(title);
      this.level.slug = slug;
      this.forceRenderKeySlug += 1;
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;

                if (_this.level.id) {
                  _this.update({
                    id: _this.level.id,
                    level: _this.level
                  }).then(function () {
                    _this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: _this.$t('#ToastMessage #Success Edit'),
                        icon: 'EditIcon',
                        variant: 'success'
                      }
                    }, {
                      timeout: 2000,
                      draggable: true,
                      hideProgressBar: false
                    });

                    _this.isVisible = false;

                    _this.$emit('input', _this.isVisible);

                    _this.loading = false;
                  });
                } else {
                  if (Math.round(_this.series.price) < 1) {
                    _this.level.isFree = true;
                  }

                  _this.create(_this.level).then(function () {
                    _this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: _this.$t('#ToastMessage #Success Save'),
                        icon: 'SaveIcon',
                        variant: 'success'
                      }
                    }, {
                      timeout: 2000,
                      draggable: true,
                      hideProgressBar: false
                    });

                    _this.isVisible = false;

                    _this.$emit('input', _this.isVisible);

                    _this.loading = false;
                  }).catch(function (error) {
                    console.warn(error);
                    _this.loading = false;
                  });
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  })
};